import type { JSX } from 'react';

import { cn } from '@/lib/utils';

import { SCOPE_LABELS, type AgentTestScope } from '../../model/scenario';

interface ScenarioScopeBadgeProps {
  scope: AgentTestScope;
}

const SCOPE_CLASSES: Record<AgentTestScope, string> = {
  global: 'bg-warning/15 text-warning',
  common: 'bg-brand-vivid/10 text-brand-vivid',
  subProject: 'border border-border-subtle text-text-muted',
};

const ScenarioScopeBadge = ({ scope }: ScenarioScopeBadgeProps): JSX.Element => (
  <span className={cn('inline-block rounded-full px-2 py-0.5 text-[0.7rem] font-semibold', SCOPE_CLASSES[scope])}>
    {SCOPE_LABELS[scope]}
  </span>
);

export default ScenarioScopeBadge;
